import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

export const useSectors = () => {
  const intl = useIntl();
  const isExtendedCatalog = useSelector(({ profile }) => profile?.isExtendedCatalog);
  const schoolSectorId = useSelector(({ profile }) => profile?.schoolSectorId);

  return useMemo(() => {
    if (isExtendedCatalog) return ['state', 'mmad', 'arab'];
    if (schoolSectorId) return [schoolSectorId];
    if (intl.locale === 'ar') return ['arab'];
    return ['state', 'mmad'];
  }, [isExtendedCatalog, schoolSectorId, intl.locale]);
};
